var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['leaderboard', 'is-hidden-mobile', { 'top-mar' : _vm.topMargin }, { 'bottom-mar' : _vm.bottomMargin }]},[_c('ins',{staticClass:"leaderboard__ad adsbygoogle leaderboard",attrs:{"data-ad-client":"ca-pub-2580109990739065","data-ad-slot":"4200499317"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b2df34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeaderBoardFluid.vue
// module id = null
// module chunks = 